import styled from 'styled-components';

export const Wrapper = styled.div`
	height: 74px;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.background.main};
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light15};
`;

export const Container = styled.div`
	height: 100%;
	max-width: 1760px;
	width: 100%;
	margin: 0 auto;
	padding: 0 20px;
	display: flex;
	align-items: center;

	@media (max-width: 1800px) {
		max-width: 1480px;
	}
`;
